import { useTranslation } from 'react-i18next';

export function RequiredTag({ alert }) {
    const { t } = useTranslation();

    return alert ? (
        <span
            className="text-xs bg-gray-100 px-1 py-0.5 rounded-full ml-2"
            style={{
                color: '#ea580c',
                fontWeight: 'bold',
            }}>
            {t(
                'sections.management.section.invoices.invoices.invoice.required'
            )}
        </span>
    ) : (
        '*'
    );
}
